(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dt-collection-flash-sale"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-dt-collection-flash]:not([data-dt-flash-ready])');
    if (!roots.length) return;

    roots.forEach((root) => {
      root.dataset.dtFlashReady = 'true';
      const extensionStart = Date.parse(root.dataset.extensionStart);
      const extensionEnd = Date.parse(root.dataset.extensionEnd);
      let end = Date.now() >= extensionStart ? extensionEnd : Date.parse(root.dataset.endsAt);
      const values = [
        root.querySelector('[data-dt-flash-hours]'),
        root.querySelector('[data-dt-flash-minutes]'),
        root.querySelector('[data-dt-flash-seconds]'),
        root.querySelector('[data-dt-flash-milliseconds]')
      ];
      let interval;
      let visible = false;

      const stop = () => {
        window.clearInterval(interval);
        interval = undefined;
      };

      const update = () => {
        const now = Date.now();
        if (now >= extensionStart && end < extensionEnd) end = extensionEnd;
        const remaining = Math.max(0, end - now);
        if (!remaining) {
          stop();
          root.hidden = true;
          return;
        }
        const parts = [
          Math.floor(remaining / 3600000),
          Math.floor((remaining % 3600000) / 60000),
          Math.floor((remaining % 60000) / 1000),
          remaining % 1000
        ];
        values.forEach((node, index) => {
          if (node) node.textContent = String(parts[index]).padStart(index === 3 ? 3 : 2, '0');
        });
      };

      const start = () => {
        stop();
        if (!visible || document.hidden) return;
        update();
        interval = window.setInterval(update, 100);
      };

      const observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        if (visible) start(); else stop();
      }, { rootMargin: '160px 0px' });

      observer.observe(root);
      document.addEventListener('visibilitychange', start);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
